import { PageListCachedDataSource } from './BaseDataSources';
import { IBalanceType } from '../Interfaces';

export class BalanceTypeSource extends PageListCachedDataSource<IBalanceType> {
  public constructor() {
    super('/datasource/balancetypes');
  }
}